import React, { useEffect } from 'react';
import { EqualitySymbol } from '../../../types/model';
import { Grid } from '@mui/material';
import TextField from '../../../../../controls/TextField';
import Dropdown from '../../../../../controls/Select';
import { Controller, useFormContext } from 'react-hook-form';

export type DecisionInput = {
    acceptLimit: number;
    acceptSymbol: string;
    denyLimit: number;
    denySymbol: string;
};

type Props = {
    acceptLimit?: number;
    acceptSymbol?: EqualitySymbol;
    denyLimit?: number;
    denySymbol?: EqualitySymbol;
};

const symbolLookup = [
    { label: 'Less Than or Equal', value: 'LTE' },
    { label: 'Less Than', value: 'LT' },
    { label: 'Equal', value: 'E' },
    { label: 'Greater Than', value: 'GT' },
    { label: 'Greater Than or Equal', value: 'GTE' },
];
const DecisionForm: React.FC<Props> = ({ acceptLimit = 0, denyLimit = 0, acceptSymbol, denySymbol }) => {
    const { register, errors, setValue } = useFormContext();
    useEffect(() => {
        register({ name: 'acceptSymbol' }, { required: 'Required' });
        register({ name: 'denySymbol' }, { required: 'Required' });
    }, [register]);

    console.log(acceptSymbol);
    return (
        <Grid container alignContent={'flex-start'} justifyContent={'center'} direction={'row'} spacing={2}>
            <Grid item xs={12} sm={5}>
                <Controller
                    name={'acceptSymbol'}
                    defaultValue={acceptSymbol?.toUpperCase() || ''}
                    render={(props) => (
                        <Dropdown
                            label={'Accept Symbol'}
                            fullWidth
                            options={[{ label: 'Accept Symbol', value: '', disabled: true }, ...symbolLookup]}
                            error={Boolean(errors.acceptSymbol)}
                            helperText={errors.acceptSymbol?.message || ' '}
                            {...props}
                        />
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={5}>
                <TextField
                    defaultValue={acceptLimit}
                    name={'acceptLimit'}
                    fullWidth
                    label={'Accept Limit'}
                    inputProps={{
                        ref: register({ required: 'Required', validate: (v: string) => !Number.isNaN(Number(v)) }),
                    }}
                    error={Boolean(errors.acceptLimit)}
                    helperText={errors.acceptLimit?.message || (errors.acceptLimit && 'Not a valid number') || ' '}
                />
            </Grid>
            <Grid item xs={12} sm={5}>
                <Controller
                    name={'denySymbol'}
                    defaultValue={denySymbol?.toUpperCase() || ''}
                    render={(props) => (
                        <Dropdown
                            label={'Deny Symbol'}
                            fullWidth
                            options={[{ label: 'Deny Symbol', value: '', disabled: true }, ...symbolLookup]}
                            error={Boolean(errors.denySymbol)}
                            helperText={errors.denySymbol?.message || ' '}
                            {...props}
                        />
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={5}>
                <TextField
                    defaultValue={denyLimit}
                    name={'denyLimit'}
                    fullWidth
                    label={'Deny Limit'}
                    inputProps={{
                        ref: register({ required: 'Required', validate: (v: string) => !Number.isNaN(Number(v)) }),
                    }}
                    error={Boolean(errors.denyLimit)}
                    helperText={errors.denyLimit?.message || (errors.denyLimit && 'Not a valid number') || ' '}
                />
            </Grid>
        </Grid>
    );
};

export default DecisionForm;
